export default "__VITE_ASSET__C9ZxGOC2__"